export function loadGlobalScript(code) {
  new Function(code).call(window);
}